import styled from 'styled-components';
import { SITE_TITLE } from '../constants';

interface ErrorMsgProps {
  visibility: boolean | number;
}

export const ErrorMessage = styled.p<ErrorMsgProps>`
  color: red;
  font-size: 0.8rem;
  margin-top: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
  visibility: ${(props) => (props.visibility ? 'visible' : 'hidden')};

  svg {
    margin-right: 5px;
  }
`;

export const SignHeadText = styled.div`
  label {
    font-size: 1.4rem;
    font-family: Arial, sans-serif;
    margin-bottom: 0.6rem;
    font-weight: 700;
  }

  label[for='title'] {
    font-size: 1.5rem;
  }

  p {
    justify-content: left;
    align-items: center;
    font-size: 1rem;
    margin-top: 8px;
    margin-bottom: 20px;

    span {
      font-weight: bold;
      text-decoration: underline;
    }
  }
`;

export const SectionTitle = styled.h1`
  font-size: 1.88rem !important;
  font-family: 'Arial' !important;
  font-weight: 700 !important;
  line-height: 42px !important;

  @media (max-width: 768px) {
    font-size: 1.25rem !important;
    line-height: 28px !important;
  }
`;
